import Preact, { h, Component } from "preact";
import { connect } from "preact-redux";
import store from "/chat/src/redux/store";

import Audio from "/chat/src/components/Audio";
import UserAgentConstants from "/chat/src/common/js/lib/UserAgentConstants";

import ChatHeader from "./Chat/Header";
import ChatBody from "./Chat/Body";

import ConversationsListHeader from "./Conversations/Header";
import ConversationsListBody from "./Conversations/Body";

import StartChattingHeader from "./StartChatting/Header";
import StartChattingBody from "./StartChatting/Body";

import OfflineHeader from "./OfflineFormular/Header";
import OfflineBody from "./OfflineFormular/Body";

import OnlineHeader from "./OnlineFormular/Header";
import OnlineBody from "./OnlineFormular/Body";

import SettingsHeader from "./Settings/Header";
import SettingsBody from "./Settings/Body";

import GDPROverlay from "./GDPROverlay/GDPROverlay";

import HelpDeskBody from "./HelpDesk/Body";
import HelpDeskHeader from "./HelpDesk/Header/Header";

import HelpDeskArticleBody from "./HelpDesk/HelpDeskArticle/HelpDeskArticle";

import SearchResults from "./HelpDesk/SearchResults/SearchResults";

import FaqHeader from "./FAQ/Header";
import FaqBody from "./FAQ/Body";

import Footer from "./Footer/Footer";

import {
  SystemModel,
  CustomizationModel,
  CompanyModel,
  FeaturesModel,
  UserModel,
} from "/chat/src/redux/model";

import style from "./style.scss";
import { Scrollbars } from "preact-custom-scrollbars";

class Router extends Component {
  constructor(props) {
    super(props);
    this._updateHeight = this._updateHeight.bind(this);
  }

  _renderRoute() {
    let header, body;

    if (this.props.activeTab === 0) {
      const helpDeskFullRoute = this.props.helpDeskRoute.split(";");
      const helpDeskRoute = helpDeskFullRoute[0];
      switch (helpDeskRoute) {
        case "HelpDeskArticle":
          header = <HelpDeskHeader />;
          body = <HelpDeskArticleBody />;
          break;
        case "HelpDeskSearch":
          header = <HelpDeskHeader />;
          body = <SearchResults />;
          break;
        case "FAQ":
          header = <FaqHeader />;
          body = <FaqBody />;
          break;
        case "HelpDesk":
        case "HelpDeskFocused":
        default:
          header = <HelpDeskHeader />;
          body = <HelpDeskBody />;
          break;
      }
    } else {
      switch (this.props.chatRoute) {
        case "Chat":
          header = <ChatHeader />;
          body = <ChatBody />;
          break;
        case "Conversations":
          header = <ConversationsListHeader />;
          body = <ConversationsListBody />;
          break;
        case "Settings":
          header = <SettingsHeader />;
          body = <SettingsBody />;
          break;
        case "StartChatting":
        default:
          if (this.props.isOffline) {
            header = <OfflineHeader />;
            body = (
              <GDPROverlay>
                <OfflineBody />
              </GDPROverlay>
            );
          } else if (this.props.formsRequire) {
            header = <OnlineHeader />;
            body = (
              <GDPROverlay>
                <OnlineBody />
              </GDPROverlay>
            );
          } else {
            header = <StartChattingHeader />;
            body = (
              <GDPROverlay>
                <StartChattingBody />
              </GDPROverlay>
            );
          }
      }
    }

    const FOOTER_HEIGHT = 40;
    return (
      <div className={style.BodyWrapper}>
        <Scrollbars
          className={style.BodyScrollbar}
          universal={true}
          renderTrackHorizontal={(props) => <div />}
          renderThumbHorizontal={(props) => <div />}
        >
          <div id="HeaderWrapper" ref={(div) => (this.header = div)}>
            {header}
          </div>
          <div id="BodyWrapper" style={{ minHeight: "50px" }}>
            {body}
          </div>
        </Scrollbars>
        {this.props.hasFeatureFooter && <Footer height={FOOTER_HEIGHT} />}
      </div>
    );
  }

  _updateHeight(shellHeight, shellWidth, headerHeight) {
    if (this.props.shellHeight !== shellHeight)
      this.props.dispatch(SystemModel.setShellHeight(shellHeight));
    if (this.props.shellWidth !== shellWidth)
      this.props.dispatch(SystemModel.setShellWidth(shellWidth));
    if (this.props.headerHeight !== headerHeight)
      this.props.dispatch(SystemModel.setHeaderHeight(headerHeight));
  }

  componentDidUpdate(prevProps, prevState) {
    this._updateHeight(
      this.shell.clientHeight,
      this.shell.clientWidth,
      this.header.clientHeight
    );
  }

  componentDidMount() {
    if (this.shell) {
      this._updateHeight(
        this.shell.clientHeight,
        this.shell.clientWidth,
        this.header.clientHeight
      );
    }
    window.addEventListener("resize", () => {
      if (this.shell) {
        this._updateHeight(
          this.shell.clientHeight,
          this.shell.clientWidth,
          this.header.clientHeight
        );
      }
    });
  }

  render() {
    var shellClassName = style.Shell;

    var isInstagram = navigator.userAgent.match(UserAgentConstants.instagram);
    if (isInstagram) shellClassName += ` ${style.ShellInstagram}`; // Instagram has some weird padding top-issues.
    return (
      <div className={shellClassName}>
        <div className={style.ShellBody} ref={(div) => (this.shell = div)}>
          {this._renderRoute()}
        </div>
        <Audio />
      </div>
    );
  }
}

function mapStateToProps(state) {
  const features = state.getIn(["features", "features"]);
  const hasFeatureFooter = features.has("faq_type");
  const isOffline = CompanyModel.isOffline(state);

  return {
    chatRoute: SystemModel.getRoute(state),
    activeTab: SystemModel.getActiveTab(state),
    helpDeskRoute: SystemModel.getHelpDeskRoute(state),
    shellHeight: SystemModel.getShellHeight(state),
    shellWidth: SystemModel.getShellWidth(state),
    headerHeight: SystemModel.getHeaderHeight(state),
    formsRequire: CustomizationModel.getFormsRequire(state),
    isOffline: isOffline,

    isShort: SystemModel.isShort(state),
    hasFeatureFooter: hasFeatureFooter,

    exchangeAvailableAndOnline:
      FeaturesModel.getExchangeAvailableAndOnline(state),
  };
}

export default connect(mapStateToProps)(Router);



// WEBPACK FOOTER //
// ./routes/index.js